import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import NavigationBar from '../components/NavigationBar'
import Footer from '../components/Footer/Footer'
import { usePois } from '../contexts/PoisContext'
import { setFlashMessage } from '../contexts/WebsiteContext'
import ClimbingList from '../components/PointOfinterestType/ClimbingList'
import ClimbingPoints from '../components/PointOfinterestType/ClimbingPoints'
import PageHeroTitle from '../components/PageHeroTitle'
import BottomImage from '../components/BottomImage'

const PoiTypeClimbing = () => {
  const poiType = 'CLIMBING'
  const pageName = `POI_TYPE_${poiType}`
  const { t, i18n } = useTranslation()
  const { pois } = usePois()

  const filteredPois = pois.filter((poi) => poi.poiType.name === poiType)

  useEffect(() => {
    if (!pois.length) {
      setFlashMessage(t('ERROR_MESSAGE'), 'error')
    }
  }, [pois, t])

  return (
    <div>
      <NavigationBar />

      <PageHeroTitle
        title={t(`${pageName}_PAGE_TITLE`)}
        description={t(`${pageName}_PAGE_DESCRIPTION`)}
      />

      <div className="container section py-4">
        <p className="lead">{t(`${pageName}_PAGE_DETAILS`)}</p>

        {filteredPois.length > 0 && <ClimbingList pois={filteredPois} />}

        <hr />
        <ClimbingPoints />

        <BottomImage name={pageName} lang={i18n.language} />
      </div>

      <Footer />
    </div>
  )
}

export default PoiTypeClimbing
